import { tw } from "@careinfo/tailwind";
import { flexRender, Table } from "@tanstack/react-table";

export default function TableHead({ table }: { table: Table<any> }) {
  return (
    <thead className={tw`bg-primary text-white uppercase`}>
      {table.getHeaderGroups().map((headerGroup) => (
        <tr key={headerGroup.id}>
          {headerGroup.headers.map((header, index) => (
            <th
              key={header.id}
              colSpan={header.colSpan}
              className={[
                index === 0
                  ? tw``
                  : headerGroup.headers?.length - 1 === index
                  ? tw` text-left w-[8rem]`
                  : tw``,
                tw`py-2 text-left px-5 whitespace-nowrap`,
              ]
                .filter(Boolean)
                .join("")}
            >
              {header.isPlaceholder
                ? null
                : flexRender(
                    header.column.columnDef.header,
                    header.getContext()
                  )}
            </th>
          ))}
        </tr>
      ))}
    </thead>
  );
}
